webpackJsonp([184662623972074],{

/***/ 806:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"1184472234930745"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-cb52c47cbacd6428e788.js